import { defineComponent as _defineComponent } from 'vue'
import { addBodyJS } from '@/helpers/html'
import LfHeaderTitleComponent from '@/components/HeaderTitle/LfHeaderTitleComponent.vue'
import { onMounted, onBeforeMount } from 'vue'
import { URLS } from '@/router/routes/urlRoutes'
import { useI18n } from 'vue-i18n-composable'
import useRouter from '@/composables/useRouter'


export default /*#__PURE__*/_defineComponent({
  __name: 'CookiesPolicyView',
  setup(__props) {

const { t } = useI18n()

// DEFINE CONST  ======================================================================================================
const title = t('views.login.footer.cookies_policy').toString()

// HOOKS ==============================================================================================================
onMounted(() => {
  addBodyJS(process.env.VUE_APP_COOKIEBOT_URL_TEXTS, '#cookies-policy', {
    id: 'CookieDeclaration',
    'type': 'text/javascript',
    async: true
  })
})

onBeforeMount(() =>{
  const router = useRouter()

  if (!process.env.VUE_APP_COOKIEBOT_ID) {
    router.goToRoute({
      name: URLS.NOT_FOUND_PAGE
    })
  }
})

return { __sfc: true,t, title, LfHeaderTitleComponent }
}

})